export default {"src":"/_next/static/media/section1-img.a9e12568.svg","height":446,"width":660,"blurWidth":0,"blurHeight":0};